if (!customElements.get('pw-shipping-protection')) {
    customElements.define('pw-shipping-protection', class extends HTMLElement {
      connectedCallback() {
        this.querySelector('button').addEventListener('click', () => this.toggle());
      }
      async toggle() {
        if (this.busy) return;
        this.busy = true;
        const button = this.querySelector('button');
        const adding = button.getAttribute('aria-checked') !== 'true';
        button.setAttribute('aria-checked', String(adding));
        const root = window.Shopify?.routes?.root || '/';
        const sections = [...document.querySelectorAll('cart-items-component')].map(n => n.dataset.sectionId).filter(Boolean).join(',');
        let events = null;
        try { events = await import('@shopify/events'); } catch (_) {}
        const deferred = events ? events.CartLinesUpdateEvent.createPromise() : null;
        if (events) {
          this.dispatchEvent(new events.CartLinesUpdateEvent({
            action: adding ? 'add' : 'remove', context: 'cart',
            lines: [{merchandiseId: this.dataset.variant, quantity: adding ? 1 : 0}], promise: deferred.promise
          }));
        }
        try {
          const url = root + (adding ? 'cart/add.js' : 'cart/change.js');
          const body = adding ? {items: [{id: Number(this.dataset.variant), quantity: 1}], sections} : {id: this.dataset.key, quantity: 0, sections};
          const res = await fetch(url, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});
          const result = await res.json();
          if (!res.ok || result.status) throw new Error(result.description || 'Cart update failed');
          const cart = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}}).then(r => r.json());
          if (deferred) {
            deferred.resolve({cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {items: cart.items, source: 'pw-shipping-protection', sections: result.sections, didError: false}});
          } else {
            location.reload();
          }
        } catch (error) {
          button.setAttribute('aria-checked', String(!adding));
          if (deferred) deferred.reject(error);
        } finally {
          this.busy = false;
        }
      }
    });
  }
